import React, { useState } from 'react';
import { Archive, ChevronDown, ChevronUp } from 'lucide-react';
import { JobFiltersComponent } from './JobFilters';
import JobsList from './JobsList';
import { JobFilters } from './types';
import { useLanguage } from '../../../contexts/LanguageContext';

const CompletedJobs = () => {
  const { t } = useLanguage();
  const [filters, setFilters] = useState<JobFilters>({
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
    department: '',
  });
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <section className="space-y-4 px-1 py-2">
      <button 
        onClick={toggleExpanded}
        className="flex items-center justify-between w-full text-left hover:bg-purple-50/30 rounded-lg transition-colors px-2 py-1"
      >
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-purple-50 rounded-lg flex items-center justify-center">
            <Archive className="w-4 h-4 text-purple-600" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h2 className="text-lg font-semibold text-gray-900">{t('dashboard.completedJobs.title')}</h2>
              <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-700 border border-purple-200">
                {t('dashboard.completedJobs.past30Days')}
              </span>
            </div>
            <p className="text-sm text-gray-500">{t('dashboard.completedJobs.subtitle')}</p>
          </div>
        </div>
        <div className="flex items-center gap-1 text-xs font-medium text-purple-600 bg-purple-50 hover:bg-purple-100 px-2 py-1 rounded transition-colors">
          {isExpanded ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
          {isExpanded ? t('common.collapseAll') : t('common.viewAll')}
        </div>
      </button>

      {isExpanded && (
        <div className="space-y-4 animate-fadeIn">
          <JobFiltersComponent filters={filters} onFilterChange={setFilters} />
          <JobsList filters={filters} />
        </div>
      )}
    </section>
  );
};

export default CompletedJobs;